<template lang='pug'>
    v-content
      IMViewSearch(:imItems="dataapproval")
</template>
<script>
import * as i18n from "../data/i18n.json";
import IMViewSearch from "@/components/IMViewSearch.vue";
import axios from "axios";
import { mapState } from "vuex";
// import { setTimeout } from "timers";
export default {
  name: "ViewApproval",
  components: {
    IMViewSearch
  },
  data() {
    return {
      i18n: i18n.default,
      dataapproval: null
    };
  },
  async mounted() {
    const p = this.$route.params;
    const url = `${this.API_URL}/report/page-detail/${p.im_no}`;
    const res = await axios.get(url);
    this.dataapproval = res.data;
  },
  computed: {
    ...mapState(["API_URL"])
  }
};
</script>
